import React from 'react';
import { List, ListItem } from '@mui/material';
import DownloadableDocumentItem from '../DownloadableDocumentItem/DownloadableDocumentItem';
import NoResult from '../NoResult/NoResult';
import { DisplayedDocument } from '../../../providers/types';

export type DownloadableDocumentsListProps = {
    documents: Array<DisplayedDocument>;
    onDownload: (fichierId: number) => void;
    onShow: (url: string) => void;
    onPreview?: (label: string, fichierId: number, documentId: number) => void;
};

const DownloadableDocumentsList: React.FunctionComponent<DownloadableDocumentsListProps> =
    function (props) {
        const { documents, onDownload: handleDownload, onShow, onPreview: handlePreview } = props;

        if (!documents.length) {
            return (
                <NoResult
                    title="Pas encore de documents"
                    description="Les fichiers partagés seront affichés ici dès leur réception"
                />
            );
        }

        // On show or onPreview can display an external file from an url or a file
        const onShowHandler = (document: DisplayedDocument) => {
            if (handlePreview && document.fichierId) {
                return handlePreview(document.label, document.fichierId as number, document.id);
            }
            if (onShow && document.fileName) {
                return () => onShow(document.fileName as string);
            }
            return () => {};
        };

        return (
            <List
                data-testid="downloadable-documents-list"
                sx={{
                    padding: '0',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '8px 0',
                }}
            >
                {documents.map((document) => (
                    <ListItem
                        key={`${document.fichierId}_${document.id}`}
                        sx={{
                            padding: '0',
                            display: 'block',
                        }}
                    >
                        <DownloadableDocumentItem
                            {...document}
                            onDownload={
                                document.fichierId
                                    ? () => handleDownload(document.fichierId as number)
                                    : () => {}
                            }
                            onShow={() => onShowHandler(document)}
                        />
                    </ListItem>
                ))}
            </List>
        );
    };

export default DownloadableDocumentsList;
